import React from 'react';
import {useTranslation} from 'react-i18next';
import {SpecificationActivity} from '../../../models/specificationViewer';

type SectionActivitiesProps = {
    activities: SpecificationActivity[];
}

const SectionActivities: React.FC<SectionActivitiesProps> = ({activities}) => {
    const {t} = useTranslation();

    if (activities.length === 0) {
        return <div className="procedure-text">{t('specificationViewer.noActivities')}</div>;
    }

    return (
        <div>
            {activities.map(activity => (
                <div className="activity-item" key={activity.id}>
                    <div className="activity-header">
                        <div className="activity-position">{activity.position}</div>
                        <div className="activity-label">
                            {t('specificationViewer.activity')} {activity.position}
                        </div>
                    </div>

                    {activity.deeps.map(deep => (
                        <div className="deep-item" key={deep.id}>
                            <div
                                className="deep-description"
                                dangerouslySetInnerHTML={{__html: deep.description}}
                            />
                            {deep.method &&
                                <div className="deep-method">
                                    {t('specificationViewer.method')}: {deep.method}
                                </div>
                            }
                            {deep.critical &&
                                <div className="deep-critical">
                                    {t('specificationViewer.critical')}
                                </div>
                            }
                            {deep.manualInstructionNumber &&
                                <div className="deep-manual">
                                    {t('specificationViewer.manualInstruction')}: {deep.manualInstructionNumber}
                                </div>
                            }
                        </div>
                    ))}

                    {activity.files.length > 0 &&
                        <div className="activity-files">
                            {activity.files.map(file => (
                                <img
                                    key={file.id}
                                    src={process.env.REACT_APP_API_ENDPOINT + 'file/uploads/' + file.path}
                                    alt={file.originalName}
                                    loading="lazy"
                                />
                            ))}
                        </div>
                    }
                </div>
            ))}
        </div>
    );
};

export default SectionActivities;
